import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, Button } from '@material-ui/core';
import ReceiptIcon from '@material-ui/icons/Receipt';

function DialogBill(props) {
  const { onClose, selectedValue, open, fullname, picture } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <img alt={fullname} src={picture} style={{ maxWidth: '100%' }} />
    </Dialog>
  );
}

DialogBill.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  fullname: PropTypes.string.isRequired,
  picture: PropTypes.string.isRequired,
};

export default function Picture({ fullname, picture }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        startIcon={<ReceiptIcon />}
        variant="contained"
        fullWidth
        onClick={handleClickOpen}
      >
        ดูใบเสร็จ
      </Button>
      <DialogBill
        selectedValue="picture"
        fullname={fullname}
        picture={picture}
        open={open}
        onClose={handleClose}
      />
    </div>
  );
}
